import {
  App,
  Button,
  Checkbox,
  Input,
  Modal,
  notification,
  Radio,
  Space,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import routes from "../../../engine/routes";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import { mainTypesPrestation } from "../../../utils/typesPrestation";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  modeInterpretariat,
  roles,
  statusPrestationsValues,
  subStatus,
} from "../../../utils/constants";
import { createPortal } from "react-dom";

import { FcCancel } from "react-icons/fc";
import { defaultProps, modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  cancelPrestation,
  getPrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";
import { AiFillCalendar } from "react-icons/ai";
import { http } from "../../../engine/api/http";

export const PrestationCancel = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loading } = useSelector(state => state.prestation);
  const { status } = prestation;
  const { user } = useContext(UserContext);

  const inputs = inputsCancel({ prestation });

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();

  const userIsInstitution = userHasLevel({
    only: {
      [roles.institution]: "r",
    },
  });


  const dateIsInPast = dayjs(prestation.finalStartDate).isBefore(dayjs(), "m");

  let canCancel = true;

  if (userIsInstitution === true && dateIsInPast === true) {
    canCancel = false;
  }


  // A second click while the cancellation runs would be refused as coming from an older copy
  const submitting = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmitForm = async data => {
    if (submitting.current) return;
    submitting.current = true;
    setIsSubmitting(true);

    try {
      if (user.role === roles.institution) {
        data.cancel.cancelAt = dayjs().format();
        data.subStatus = subStatus.institution;
      }

      const updated = {
        status: statusPrestationsValues.cancel,
        subStatus: data.subStatus,
        cancel: {
          cancelNote: data.cancel.cancelNote,
          cancelAt:
            data.cancel.cancelAt === null
              ? dayjs().format()
              : data.cancel.cancelAt,
          cancelBy: user._id,
        },
      };

      await dispatch(setPropertiesPrestation(updated));
      await dispatch(cancelPrestation());

      // if (prestation.institution.groupedBilling === true) {
      //   const syncBills = await http.post(`/bills/multiple`, {
      //     institutionId: prestation.institution._id,
      //     prestation: prestation._id,
      //   });
      // } else {
      //   const syncBill = await http.post(`/bills/upsertOneBillOnePrestation`, {
      //     prestation: prestation._id,
      //   });
      // }

      await dispatch(getPrestation(prestation._id));

      close();
    } finally {
      submitting.current = false;
      setIsSubmitting(false);
    }
  };

  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationCancel);
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationCancel,
    containerStyle: { minWidth: "500px" },
    title: "Voulez-vous annuler la prestation ?",
    open: open,
    cancelText: "Fermer",
    okText: canCancel ? "Je veux annuler la prestation" : null,
    onOk: () => {
      if (canCancel) {
        formRef.current.submit();
      }
    },
    onCancel: close,
    content: (
      <>
        {canCancel ? (
          <p>
            Il ne sera pas possible de venir en arriète pour cette prestation.
          </p>
        ) : (
          <p>
            Cette prestation sera clôturée par l’interprète dans les plus brefs
            délais.
          </p>
        )}

        {canCancel && onlyRoleMapping([roles.institution]) && (
          <cite>Annulation par l'institution (facturée sous condition)</cite>
        )}

        {canCancel && (
          <CustomForm
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        )}
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      canCancel ? (
        <Button
          icon={<MdOutlineFreeCancellation size={20} />}
          type="primary"
          loading={isSubmitting}
          disabled={isSubmitting}
          onClick={async () => {
            try {
              const test = await formRef.current.validateFields();
              formRef.current.submit();
            } catch (e) {
              notification.error({
                message: e.errorFields.length + " champs est nécessaire",
              });
            }
          }}
        >
          Confirmer l'annulation
        </Button>
      ) : null,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsCancel = ({ prestation, user }) => {
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    tags,
    cancel,
    interventionLocation,
  } = prestation;

  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Raison de l'annulation\n",
          required: true,
          name: "subStatus",
          type: "radios",
          value: prestation.subStatus,
          size: "small",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
            },
          }),
          radios: [
            {
              label: "Annulation par l'institution (facturée sous condition)",
              value: subStatus.institution,
            },
            {
              label:
                "Annulation par l'interprète sur absence du client (facturée)",
              value: subStatus.interprete,
            },
            {
              label: "Annulation par la permanance (non facturée)",
              value: subStatus.permanance,
            },
            {
              label: "Annulation doublon  (non facturée, non notifié)",
              value: subStatus.duplicate,
            },
          ],
          col: 24,
        },
        {
          label: "Date de l'annulation",
          quote: "Automatique si non renseignée",
          name: "cancel.cancelAt",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "r", //
              [roles.admin]: "r", //
            },
          }),
          value: cancel?.cancelAt ? dayjs(cancel.cancelAt) : null,
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date-time",
          col: 24,
        },
        {
          label: "Raison de l'annulation",
          required: true,
          name: "cancel.cancelNote",
          type: "textarea",
          value: cancel?.cancelNote || "",
          rows: 4,
          col: 24,
        },
      ],
    },
  ];
};
